module.exports = __webpack_public_path__ + "img/selected_virtual_off.f8585811.svg";